export default __webpack_public_path__ + "static/science-c9cb42a8dd0d3b9b2fda4271e7ffa94d.jpg";